
import { EntitiesStore } from './entities-store.abstract';
import { HttpClient } from '@angular/common/http';
import { of, merge } from 'rxjs';
import { CountryDependencyEntityStore } from './country-dependency-entity-store';
import { Injector } from '@angular/core';
import { mergeMap, tap, map, filter } from 'rxjs/operators';
import { environment } from '../../../../environments/environment.prod';


/**
 * Interface for member association data
 *
 * @export
 * @interface IMemberAssociation
 */
export interface IMemberAssociation {
  MaId: number;
  MaCode: string;
  MaName: string;
  NOC: string;
  CName: string;
  Founded: number;
  Affiliated: number;
  CShort: string;
  MaStatusCode: number;
  MaStatus: string;
  CaId: number;
  CaCode: string;
  CaName: string;
  Continent: string;
  HeaderImage: {URL:string};
  Address: Address;
  Functions: MembersFunctionsItem[];
  Links: Links;
  Logo: Logo;
  Coordinates: Coordinates;
}
interface Coordinates {
  lat: number;
  long: number;
}
interface Address {
  Contact: string;
  Address: string;
  Zip: string;
  Place: string;
  State: string;
  CountryCode: string;
  ContryName: string;
  Notes: string;
  Latitude:number;
  Longitude:number;
}

interface MembersFunctionsItem {
  Id: number;
  Function: string;
  Title: string;
  FName: string;
  GName: string;
  WNameOrd: boolean;
}

interface Links {
  'E-Mail': string[];
  Mobile: string;
  Phone: string;
  Web: string;
}

interface Logo {
  URL: string;
  MimeType: string;
  Base64: string;
}


/**
 * Store fore getting the members stats
 *
 * @export
 * @class MembersAssociationsStatsStore
 * @extends {EntitiesStore<SeasonMembersStats>}
 */
export class MemberIndividualAssociationStore extends EntitiesStore<IMemberAssociation> {
  constructor(http: HttpClient, injector: Injector) {
    super('MEMBERASSOCIATION', http, [{ entity: new CountryDependencyEntityStore(http, injector) }]);
  }

  /**
   * Implementation for getting the coordinates calling to api
   *
   * @param {*} params
   * @param {boolean} request_more
   * @returns
   * @memberof MemberIndividualAssociationStore
   */
  getRequest(params: any, request_more: boolean) {
    if(params.Noc===undefined){
      return of([] as any);
    }
    return super.getRequest(params, request_more)
  }
}
